import React, { useContext, useEffect, useState } from "react";
import estilo from "./styles/DatosUsuario.module.css";
import supabase from "../supabase/supabaseClient";
import { DataContext } from "../context/DataContext";

function DatosUsuario({ dato }) {
  const { setFotoSubida, click, setClick } = useContext(DataContext);

  const [imagen, setImagen] = useState([]);
  const [sexo, setSexo] = useState("");
  const [mostrarImagen, setMostrarImagen] = useState([]);
  const [formDatos, setFormDatos] = useState({
    edad: "",
  });
  const [condicionesValidas, setCondicionesValidas] = useState(false);
  const [validaciones, setValidaciones] = useState({
    edad: false,
    sexo: false,
    foto: false,
  });

  //captura de inputs
  function capturarInputs(e) {
    const name = e.target.name;
    const value = e.target.value;

    if (name === "edad") {
      const edad = parseInt(value);
      if (isNaN(edad) || edad < 18) {
        setValidaciones((prevValidaciones) => {
          return {
            ...prevValidaciones,
            edad: false,
          };
        });
        console.log("Edad inválida");
      } else {
        setValidaciones((prevValidaciones) => {
          return {
            ...prevValidaciones,
            edad: true,
          };
        });
        console.log("Edad válida");
      }
    }

    setFormDatos((prevFormDatos) => {
      return {
        ...prevFormDatos,
        [name]: value,
      };
    });
  }

  //capturar sexo
  function capturarValor(e) {
    setSexo(e.currentTarget.dataset.value);
    if (e.currentTarget.dataset.value) {
      setValidaciones((prevValidaciones) => {
        return {
          ...prevValidaciones,
          sexo: true,
        };
      });
    }
  }

  //capturar imagen
  function capturarImagen(e) {
    const files = Array.from(e.target.files);
    setImagen(files);
    setMostrarImagen(URL.createObjectURL(files[0]));
    if (files) {
      setValidaciones((prevValidaciones) => {
        return {
          ...prevValidaciones,
          foto: true,
        };
      });
    }
  }

  //verificar condiciones
  useEffect(() => {
    // Verificar si todas las validaciones son true
    const todasLasValidacionesSonTrue = Object.values(validaciones).every(
      (validacion) => validacion === true
    );

    // Actualizar el estado de condicionesValidas
    setCondicionesValidas(todasLasValidacionesSonTrue);
  }, [validaciones]);

  //insertar datos en tabla
  async function insertarDatos(e) {
    e.preventDefault();
    if (dato) {
      const { data, error } = await supabase
        .from("usuarios_chat")
        .insert({
          user_id: dato.id,
          nombre_usuario: dato.user_metadata.first_name,
          correo: dato.email,
          sexo: sexo,
          edad: formDatos.edad,
          estado: true,
          disponible: true,
        })
        .select();

      if (data) {
        subirFoto();
        setClick(!click);
      }
      if (error) {
        console.log(error);
      }
    } else {
      console.log("Datos de usuario incompletos");
    }
  }

  //subir foto
  async function subirFoto() {
    if (dato) {
      for (const image of imagen) {
        const { data, error } = await supabase.storage
          .from("fotos_perfil")
          .upload(`perfil/${dato.id}`, image);

        if (data) {
          setFotoSubida(true);
        }
        if (error) {
          console.log(error);
        }
      }
    }
  }

  return (
    <div className={estilo.datos_usuario}>
      <div className={estilo.contenido}>
        <div className={estilo.descripcion}>
          <h2>
            S<em>Person</em>
          </h2>
          <p>Ingresa tus información para poder continuar</p>
        </div>
        <form onSubmit={insertarDatos}>
          <div className={estilo.input_datos}>
            <input
              type="number"
              placeholder="Edad"
              name="edad"
              onChange={capturarInputs}
              required
            />
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className={
                validaciones.edad ? estilo.validacion : estilo.no_validacion
              }
            >
              <path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path>
            </svg>
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path d="M12 2a9.936 9.936 0 0 0-7.071 2.929C3.04 6.818 2 9.33 2 12s1.04 5.182 2.929 7.071C6.818 20.96 9.33 22 12 22s5.182-1.04 7.071-2.929C20.96 17.182 22 14.67 22 12s-1.04-5.182-2.929-7.071A9.936 9.936 0 0 0 12 2zm5.657 15.657C16.146 19.168 14.137 20 12 20s-4.146-.832-5.657-2.343C4.832 16.146 4 14.137 4 12s.832-4.146 2.343-5.657A7.927 7.927 0 0 1 11 4.069V12a1 1 0 0 0 1 1h7.931a7.927 7.927 0 0 1-2.274 4.657zM13 11V4.062a7.945 7.945 0 0 1 4.657 2.281A7.934 7.934 0 0 1 19.938 11H13z"></path>
            </svg>
          </div>

          <div className={estilo.sexos}>
            <p>Selecciona un sexo</p>

            <div className={estilo.seleccion}>
              <p
                onClick={capturarValor}
                data-value="Hombre"
                className={
                  sexo === "Hombre" ? estilo.activoSexo : estilo.no_activoSexo
                }
              >
                Hombre
              </p>
              <p
                onClick={capturarValor}
                data-value="Mujer"
                className={
                  sexo === "Mujer" ? estilo.activoSexo : estilo.no_activoSexo
                }
              >
                Mujer
              </p>
            </div>
          </div>

          <div className={estilo.foto}>
            <p>Foto de Perfil</p>
            <input
              type="file"
              accept="image/*"
              onChange={capturarImagen}
              required
            />
          </div>

          <button
            type="submit"
            disabled={!condicionesValidas}
            className={
              condicionesValidas
                ? estilo.boton_registrar
                : estilo.no_boton_registrar
            }
          >
            Guardar
          </button>
        </form>
      </div>
    </div>
  );
}

export default DatosUsuario;
